import { styled } from '@mui/material/styles';
import BasePaper from '@mui/material/Paper';

export const Paper = styled(BasePaper)(({ theme }) => ({
  borderRadius: theme.borderRadius.base
}));
